import { useEffect, useRef } from 'react';

import { MODAL_MESSAGES } from "../../components/common/helpers";
import { addInvestment, sendEmailApproval } from '../../actions/investments';

import { useDispatch } from 'react-redux';

const GooglePayButton = ({
  user, newInvestment,
  setModalContent, setShowModal, disabled = false
}) => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);

  // Carga el script solo una vez
  useEffect(() => {
    if (document.getElementById('google-pay-js')) return;

    const script = document.createElement('script');
    script.id = 'google-pay-js';
    script.src = 'https://pay.google.com/gp/p/js/pay.js';
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    // Solo crear el botón si aún no existe
    if (!window.google || disabled || !window.google.payments) {
      if (containerRef.current?.firstChild) {
        containerRef.current.firstChild.style.display = 'none';
      }
      return;
    }

    const paymentsClient = new window.google.payments.api.PaymentsClient({ environment: process.env.REACT_APP_GOOGLE_PAY_ENVIRONMENT });

    // Limpia el botón anterior si existe
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    const button = paymentsClient.createButton({
      onClick: onGooglePayClicked,
      buttonColor: 'black',
      buttonType: 'buy',
    });

    containerRef.current.appendChild(button);
  }, [disabled]);

  const onGooglePayClicked = async () => {
    try {
      const paymentsClient = new window.google.payments.api.PaymentsClient({ environment: process.env.REACT_APP_GOOGLE_PAY_ENVIRONMENT });

      const paymentDataRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [{
          type: 'CARD',
          parameters: {
            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
            allowedCardNetworks: ['MASTERCARD', 'VISA', 'AMEX'],
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              gateway: 'stripe',
              'stripe:version': '2020-08-27',
              'stripe:publishableKey': process.env.REACT_APP_STRIPE_PUBLISHABLE_KY, // reemplaza
            },
          }
        }],
        merchantInfo: {
          merchantId: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID, // usa "TEST" para pruebas
          merchantName: 'ONE SERVICES MEXGRO',
        },
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPriceLabel: 'Total',
          totalPrice: newInvestment.monto.toString(),
          currencyCode: 'MXN',
          countryCode: 'MX',
        },
      };

      const paymentData = await paymentsClient.loadPaymentData(paymentDataRequest);
      const parsedToken = JSON.parse(paymentData.paymentMethodData.tokenizationData.token);
      const token = parsedToken.id;
      const precioCentavos = Math.floor(newInvestment.monto * 100);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/payments/process-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token,
          amount: precioCentavos,
        }),
      })
      const data = await res.json()
      if (data.success && data.paymentIntent.status === 'succeeded') {
        const info = {
          monto: Math.floor(data.paymentIntent.amount / 100),
          recibo: [data.paymentIntent.id],
          metodo: 'googlePay',
          status: 1,
          tipo: "Servicio",
          servicio: newInvestment?.servicio
        };
        console.log('Pago exitoso:', info);
        const emailData = {
          subject: 'aprobacion',
          email: user.email,
          nombre: user.name,
          servicio: true
        };
        await dispatch(addInvestment(info, user._id, user.datos_empresas[0]._id));
        await sendEmailApproval(emailData);
        const result = MODAL_MESSAGES.SUCCESS_INVERSION;
        setModalContent(result);
        setShowModal(true);
      } else {
        console.error('Error en el pago:', data);
        alert('Error al procesar pago');
      }
    } catch (err) {
      if (err.statusCode === 'CANCELED') {
        console.log('Pago cancelado por el usuario.');
        // Aquí puedes hacer algo opcional, o simplemente no hacer nada.
        return;
      }
    }
  };

  return <div id="google-pay-button" ref={containerRef}></div>;
};

export default GooglePayButton;